import { useMotionValueEvent, useScroll } from 'framer-motion';
import { type RefObject, useState } from 'react';

const useIsCarouselScrolledToBottom = (
  carouselRef: RefObject<HTMLDivElement | null>,
): boolean => {
  const [isCarouselScrolledToBottom, setIsCarouselScrolledToBottom] =
    useState<boolean>(false);
  const { scrollY } = useScroll();

  useMotionValueEvent(scrollY, 'change', (latest) => {
    const carouselBottom = carouselRef.current?.getBoundingClientRect().bottom;
    const parentBottom =
      carouselRef.current?.parentElement?.getBoundingClientRect().bottom;
    // Consider carouselBottom to be equal to parentBottom if within 0.5 pixels
    const doesMatchWithinThreshold =
      carouselBottom != null &&
      parentBottom != null &&
      Math.abs(carouselBottom - parentBottom) < 0.5;

    if (doesMatchWithinThreshold && latest > 10) {
      if (!isCarouselScrolledToBottom) {
        setIsCarouselScrolledToBottom(true);
      }
    } else {
      if (isCarouselScrolledToBottom) {
        setIsCarouselScrolledToBottom(false);
      }
    }
  });

  return isCarouselScrolledToBottom;
};

export default useIsCarouselScrolledToBottom;
